// extracted by mini-css-extract-plugin
export default {"img":"SupplierField_img__0VSlh"};